import React from 'react'
import Postit from './Postit'
import Link from './Link'

const PostitTeaser = ({ item, className }) => {
  return (
    <section
      className={`stacked-teaser-item stacked-teaser-item-postit ${className}`}
    >
      <article>
        <Link link={item.link}>
          <Postit text={item.text} />
        </Link>
      </article>
    </section>
  )
}

export default PostitTeaser
